import { render, staticRenderFns } from "./SdtAudit.vue?vue&type=template&id=2b3d2c2a"
import script from "./SdtAudit.vue?vue&type=script&lang=js"
export * from "./SdtAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports